import React, { useState, useContext } from 'react'
import { useSelector } from 'react-redux';
import Tabs, { TabContent } from 'components/Tabs/SerialNumberSwiperHashTabs';
import Exchange from 'components/pages/SerialNumber/TabContent/Exchange';
import Giveaway from 'components/pages/SerialNumber/TabContent/Giveaway';
import Vote from 'components/pages/SerialNumber/TabContent/Vote';
import { GlobalContext } from 'store/context/GlobalContext';
import { AttrText } from 'components/AttrText';

export default function SerialNumber() {
    const user = useSelector((state) => state.Auth.user);
    const [ tab, setTab ] = useState();
    const context = useContext(GlobalContext);
    const { userData } = context;

    return (<>
        <div className="inner-bg"></div>
        <div className="inner-page serialNumber-page">
            <Tabs to="/serial-number" defaultValue="#exchange" value={tab} onChange={setTab} ></Tabs>
            <div className="inner-container">
                <AttrText className="name" text={user.login_name}>{user.login_name}</AttrText>
                <div className="record-box">
                    <ul className="record-list">
                        <li className="record-item">
                            <div>已登錄點數</div>
                            <div className="count">{userData.user_points ? userData.user_points : "0"} 點</div>
                        </li>
                        <li className="record-item">
                            <div>已使用</div>
                            <div className="count">{userData.user_used_points ? userData.user_used_points : "0"} 點</div>
                        </li>
                        <li className="record-item">
                            <div>剩餘</div>
                            <div className="count">{userData.user_last_points ? userData.user_last_points : "0"} 點</div>
                        </li>
                    </ul>
                    <div className="text-secondary font-size-14 mgt-3 pdx-3">每1張瓶貼序號即代表1點，亦有機會隨機出現2點、5點或10點。</div>
                </div>
                <TabContent value={tab ? tab : "#exchange"}>
                    <Exchange value="#exchange" />
                    <Giveaway value="#giveaway" />
                    <Vote value="#vote" />
                </TabContent>
            </div>
        </div>
    </>)
}